import { useState } from 'react';
// @mui
import {
  Stack,
  Divider,
  Typography,
  IconButton,
} from '@mui/material';
// next
import { useRouter } from 'next/router';
// hooks
import useCompany from '../../hooks/useCompany';
// components
import Avatar from '../../components/Avatar';
import Scrollbar from '../../components/Scrollbar';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
import {
  CrewProfileDialog,
} from '../crews';
// utils
import { fKrDateKST } from '../../utils/formatTime';
import { PATH_TODO } from '../../routes/paths';

export default function CrewsList() {
  const { crews } = useCompany();
  const [selectedProfile, setSelectedProfile] = useState(null);

  const setProfileIfActive = (e, row) => {
    e.stopPropagation();
    if (row.is_active) {
      setSelectedProfile(row);
    } else {
      setSelectedProfile(null);
    }
  }

  return (
    <Scrollbar>
      <Stack
        divider={<Divider orientation="horizontal" flexItem />}
      >
        {crews && crews.map((row) => (
          <CrewsListItem
            key={row.id}
            row={row}
            openProfileDialog={(e, row) => setProfileIfActive(e, row)}
          />
        ))}
      </Stack>
      <CrewProfileDialog
        isOpen={Boolean(selectedProfile)}
        closeDialog={() => setSelectedProfile(null)}
        crew={selectedProfile}
      />
    </Scrollbar>
  )
}

function CrewsListItem({
  row,
  openProfileDialog,
}) {
  const {
    id,
    randomhash,
    contract_end_date,
    nickname,
    get_position_display,
    is_active,
  } = row;

  const getStatusColor = (isActive) => {
    return isActive ? 'info' : 'default';
  };

  const router = useRouter();

  const pushToCrew = () => {
    router.push({pathname: PATH_TODO.detail, query: {c: id}})
  }

  return (
    <Stack
      direction="row" alignItems="center" justifyContent="space-between" sx={{ pl: 2, pr: 1, py: 2.5 }}
      onClick={pushToCrew}
    >
      <Stack spacing={1} sx={{ overflow: 'hidden' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${randomhash || '5'}.png`}
            alt={nickname}
            sx={{
              width: 32,
              height: 32,
            }}
          />
          <Typography variant="subtitle2" noWrap sx={{ textOverflow: 'ellipsis' }} onClick={(e) => openProfileDialog(e, row)}>
            {nickname}
          </Typography>
          <Label variant="outlined" sx={{ minWidth: 50 }}>
            {get_position_display}
          </Label>
          <Label color={getStatusColor(is_active)} sx={{ minWidth: 50 }}>
            {is_active ? '계약 중' : '계약 종료'}
          </Label>
        </Stack>
        <Typography variant="body2">
          계약 종료일: {fKrDateKST(contract_end_date)}
        </Typography>
      </Stack>
      <Iconify sx={{ ml: 1, minWidth: 20, minHeight: 20, width: 20, height: 20, color: 'text.disabled' }} icon={'ic:baseline-chevron-right'} />
    </Stack>
  );
}
